<template>
    <div class="container">
        <navigation />

        <div class="row">
            <div class="col-12 text-left">
                <a @click="$router.go(-1)" class="btn btn-link btn-back-link">&laquo; Back</a>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h1>Redeemed Rewards</h1>
            </div>
        </div>

        <div class="row" v-if="errorMessages.length > 0">
            <div class="col-12">
                <div v-for="error in errorMessages" v-bind:key="error">
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="transactionsFetched && transactions.length > 0">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <div class="transaction-list row">
                            <div class="col-xs transaction" v-for="(transaction, index) in transactions" :key="index">
                                <p class="transaction-date">{{ formatDate(transaction.transactionDateTime) }}</p>
                                <p class="transaction-location">{{ transaction.siteName }}</p>
                                <div v-if="transaction.rewards.length > 0" class="redeemed-rewards">
                                    <div v-for="(reward, rewardIndex) in transaction.rewards" :key="rewardIndex">
                                        <div v-if="reward.offers.length > 0">
                                            <div v-for="(offer, offerIndex) in reward.offers" :key="offerIndex">
                                                <p class="offer-description">{{ offer.offerDescription }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pagination">
                    <div class="col-sm-6">
                        <a href="#" v-if="pageNumber > 1" v-on:click="getPreviousPage" class="btn btn-primary btn-bellstores">&laquo; Previous</a>
                    </div>
                    <div class="col-sm-6 text-right">
                        <a href="#" v-if="hasMore" v-on:click="getNextPage" class="btn btn-primary btn-bellstores">Next &raquo;</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else-if="!transactionsFetched">
            <div class="col-12">
                <div class="spinner-wrapper">
                    <font-awesome-icon :icon="spinnerIcon" class="spinner"></font-awesome-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'
import moment from 'moment'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

export default {
    name: 'RedeemedRewards',
    dependencies: ['apiService', 'storageService'],
    data () {
        return {
            transactions: [],
            errorMessages: [],
            transactionsFetched: false,
            pageNumber: 1,
            hasMore: false
        }
    },
    async mounted () {
        await this.getTransactions(this.pageNumber)
    },
    methods: {
        formatDate (dateStr) {
            return moment(dateStr).format('l')
        },
        async getTransactions (pageNumber) {
            const response = await this.apiService.transactionHistory(pageNumber)
            if (response instanceof APIRequestError || response instanceof APIResponseError) {
                this.errorMessages.push(response.message())
                this.transactionsFetched = true
                return
            }

            this.transactions = response.transactions()
            this.hasMore = response.moreAvailable()
            this.transactionsFetched = true
            console.log(this.transactions)
        },
        async getNextPage (e) {
            e.preventDefault()
            this.transactionsFetched = false
            await this.getTransactions(++this.pageNumber)
        },
        async getPreviousPage (e) {
            e.preventDefault()
            this.transactionsFetched = false
            await this.getTransactions(--this.pageNumber)
        }
    },
    computed: {
        spinnerIcon () {
            return faSpinner
        }
    }
}
</script>

<style scoped lang="scss">
    .spinner-wrapper {
        margin-top: 20px;

        .fa-spinner {
            width: 50px;
            height: 50px;
        }
    }

    .pagination {
        margin-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/RedeemedRewards.vue